
import { mapGetters } from "vuex";
export default {
  name: "Cancelamento",
  data: () => ({
    listaDeVendas: [],
    loading: false,
    dialog: false,
    snackbar: false,
    vendaACancelar: {},
    headers: [
      {
        text: "ID",
        value: "id",
        align: "center",
      },
      {
        text: "Contratante",
        value: "contratante",
        align: "start",
      },
      {
        text: "Abertura",
        value: "abertura",
        align: "center",
      },
      {
        text: "Data do pedido",
        value: "data",
        align: "center",
      },
      {
        text: "Plano",
        value: "plano",
        align: "center",
      },
      {
        text: "Ações",
        value: "actions",
        align: "center",
      },
    ],
  }),
  computed: {
    ...mapGetters("usuario", { usuario: "getUsuario" }),
  },
  methods: {
    getVendas() {
      this.loading = true;
      this.$http
        .get(`/vendas/status/aguardando-cancelamento`)
        .then((vendas) => {
          this.loading = false;
          this.listaDeVendas = vendas.data;
        })
        .catch(() => {
          this.loading = false;
          this.snackbar = true;
        });
    },
    confirmCancelation(venda) {
      this.dialog = true;
      this.vendaACancelar = venda;
    },
    confirm() {
      this.loading = true;
      this.$http
        .put(`/venda/status/${this.vendaACancelar.id}`, {
          status: "cancelado",
          userID: this.usuario.id,
          userName: this.usuario.nome,
        })
        .then(() => {
          this.dialog = false;
          this.loading = false;
          this.getVendas();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deny() {
      this.loading = true;
      this.$http
        .put(`/venda/status/${this.vendaACancelar.id}`, {
          status: "em análise",
          userID: this.usuario.id,
          userName: this.usuario.nome,
        })
        .then(() => {
          this.dialog = false;
          this.loading = false;
          this.getVendas();
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  filters: {
    dataFormatada: function (value) {
      if (value) {
        let d = value.split("-");
        let dia = d[2].split("T")[0];
        let mes = d[1];
        let ano = d[0];

        return `${dia}/${mes}/${ano}`;
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.getVendas();
  },
};
